import React, { useState } from 'react';

import {
  Text, Wrap, WrapItem, Image,
} from '@chakra-ui/react';

import ZoomImage from 'containers/Modals/ZoomImage';

export default function Breakdowns({ execution }) {
  const [image, setImage] = useState<string>();

  return (
    <Wrap>
      <ZoomImage
        isOpen={!!image}
        onClose={() => setImage(undefined)}
        data={image}
      />
      {execution?.fields?.map(({ description, imageUrl }, index) => (
        <WrapItem
          cursor="pointer"
          onClick={() => setImage(imageUrl)}
          p={4}
          borderRadius={8}
          alignItems="center"
          bg="white.default"
          height={100}
          width="32%"
          key={`breakdown-${index}`}>
          <Image
            height={20}
            objectFit="contain"
            src={imageUrl}
          />
          <Text
            variant="mediumSemiBold"
            ml={2}>
            {description}
          </Text>
        </WrapItem>
      ))}
      <WrapItem
        p={4}
        borderRadius={8}
        alignItems="center"
        bg="white.default"
        height={100}
        width="32%">
        <Image src="/images/image-placeholder.png" />
        <Text
          variant="mediumSemiBold"
          ml={2}>
          Descrição
        </Text>
      </WrapItem>
    </Wrap>
  );
}
